import React from 'react';
import { __ } from 'artsteps2-common';
import utils from '../../../utils';
import { compose, withState, withDispatch } from '../../../enhancers';
import { addMessage, setUIData } from '../../../actions';
import { getUIProperty, getAuthUser } from '../../../reducers';

export const ArtifactView = ({
  artifact = {},
  placing = false,
  selected = false,
  disabled = false,
  controls = false,
  onPlaceArtifact = () => Promise.resolve(false),
  onStopPlacing = () => Promise.resolve(false),
  onEditorOpen = () => Promise.resolve(false),
  onAddMessage = () => Promise.resolve(false),
}) => (
  <div className="artifact-wrapper">
    <div
      className={`artifact
        ${placing ? 'placing' : ''}
        ${selected ? 'selected' : ''}
        ${disabled ? 'disabled' : ''}
      `}
    >
      <img
        className="ui tiny image centered"
        draggable={!disabled}
        onDragEnd={({ dataTransfer: { dropEffect = 'none' } = {} }) =>
          dropEffect !== 'none' && onPlaceArtifact()
        }
        onDoubleClick={() => controls && onEditorOpen()}
        onClick={() => (placing ? onStopPlacing() : onPlaceArtifact())}
        src={utils.artifact.getArtifactImage(artifact)}
        alt={artifact.title}
      />
      {controls && !disabled && (
        <div className="artifact-controls">
          <button
            className={`artifact-button ${placing ? 'disabled' : ''}`}
            onClick={onEditorOpen}
            data-tooltip={__('edit')}
            data-inverted
            data-position="left center"
          >
            <i className="ui icon edit" />
          </button>
        </div>
      )}
    </div>
  </div>
);

const mapState = (state, { exhibitionId, artifact = {} }) => {
  const placingArtifact = getUIProperty(state, `exhibitions/${exhibitionId}/placingArtifact`);
  const selectedArtifact = getUIProperty(state, `exhibitions/${exhibitionId}/selectedArtifact`);
  const currentUser = getAuthUser(state);
  return {
    currentUser,
    placing: placingArtifact && (placingArtifact.artifactId || placingArtifact) === artifact._id,
    selected: selectedArtifact === artifact._id,
    disabled:
      (placingArtifact && (placingArtifact.artifactId || placingArtifact) !== artifact._id) ||
      getUIProperty(state, `exhibitions/${exhibitionId}/painting`) ||
      getUIProperty(state, `exhibitions/${exhibitionId}/placingCase`),
  };
};

const mapDispatch = (dispatch, { artifact = {}, exhibitionId, placing }) => ({
  onPlaceArtifact: () =>
    utils.exhibition.exportArtifact(artifact).then(exportedArtifact =>
      dispatch(
        setUIData(`exhibitions/${exhibitionId}`, {
          placingArtifact: exportedArtifact,
          placingCase: undefined,
        }),
      ),
    ),
  onStopPlacing: () =>
    dispatch(
      setUIData(`exhibitions/${exhibitionId}`, {
        placingCase: undefined,
        placingArtifact: undefined,
      }),
    ),
  onEditorOpen: () =>
    dispatch(
      setUIData('artifacts', {
        editingArtifactId: artifact._id,
        editingArtifactType: artifact.type,
      }),
    ),
  onAddMessage: message => dispatch(addMessage(message, 'artifacts')),
});

const Artifact = compose(withState(mapState), withDispatch(mapDispatch))(ArtifactView);

export default Artifact;
